import { getStored } from '../state/clientStorage'

export const isDevelopmentMode = () => !!getStored('dev')
